import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {TaskDetailedServiceTimeModel} from "../../../models/task-detailed-service-time.model";
import {
  TaskDetailedServiceTimeEditComponent
} from "../task-detailed-service-time-edit/task-detailed-service-time-edit.component";
import {PanelService} from "../../../../commons/angular/services/panel.service";


require('./task-detailed-service-time.scss');
@Component({
  standalone: false,
  selector: 'app-task-detailed-service-time',
  templateUrl: './task-detailed-service-time.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskDetailedServiceTimeComponent implements OnInit {

  @Input() detailedServiceTime: TaskDetailedServiceTimeModel;
  @Input() isAllowEdit: boolean;
  @Input() fontSize = 'br-body-2';
  @Input() ignorePackageServiceTime: boolean = false;
  @Output() onChange = new EventEmitter<TaskDetailedServiceTimeModel>();

  public isShowEditButton: boolean = false;

  constructor(@Inject(PanelService) private panelService: PanelService) {
  }

  ngOnInit() {

  }

  onToggleEdit(event) {
    const panel = this.panelService.open(TaskDetailedServiceTimeEditComponent, event, {
      detailedServiceTime: this.detailedServiceTime,
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      height: 370
    })

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        if (!!data.detailedServiceTime) {
          this.onChange.emit(data.detailedServiceTime);
        }
      })
    }
  }
}
